import React, { Component } from 'react';

import _ from 'lodash';

import UserPanel from '../../user-panel/user-panel';
import { ErrorModal } from '../../ui/modals';

export default class Sidebar extends Component {
    state = {
        visible: false
    }

    toggleModal = (show=null) => {
        if(!_.isNull(show)) {
            this.setState({
                visible: show
            });
        } else {
            this.setState({
                visible: !this.state.visible
            });
        }
    }

    render() {
        return (
            <React.Fragment>
            <aside className="main-sidebar">
                <section className="sidebar">
                    <UserPanel />
                    {this.props.children}
                    <ul className="sidebar-menu">
                        <li onClick={this.toggleModal}>
                            <a href={window.location.href}>
                                <i className='icon-turn-off' style={{ margin: 0, marginLeft: -5, fontSize: 25 }} />
                                <span style={{verticalAlign: 'super', fontSize: '1.6rem'}}>&nbsp;&nbsp;Sair</span>
                            </a>
                        </li>
                    </ul>
                </section>
            </aside>
            <ErrorModal
                isVisible={this.state.visible}
                style={{top: 35}}
                title="Sair"
                text="Você realmente gostaria de sair do sistema?"
                icon="icon-turn-off"
                btnCancel={{
                    text: 'Não',
                    onClick: () => this.toggleModal(false)
                }}
                btnOk={{
                    text: 'Sim',
                    onClick: () => window.location.replace('#/logout')
                }}
            />
            </React.Fragment>
        );
    }
}